import { render, staticRenderFns } from "./ESituacaoAtendimento.vue?vue&type=template&id=7bddd26d"
import script from "./ESituacaoAtendimento.vue?vue&type=script&lang=js"
export * from "./ESituacaoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports